/* Lightweight toast system (Zustand store + host). Non-blocking notifications
   per ТР-ОБ-08. */
import { create } from 'zustand'
import { Icon } from '@/ds/icons'
import { cn } from '@/lib/cn'

export type ToastTone = 'info' | 'success' | 'danger'
interface ToastItem {
  id: number
  tone: ToastTone
  title: string
  text?: string
  /* Помечается за момент до удаления: элемент обязан дожить до конца ухода,
     иначе он просто исчезает, а исчезновение читается как сбой. */
  leaving?: boolean
}
interface ToastStore {
  items: ToastItem[]
  push: (t: Omit<ToastItem, 'id'>) => void
  dismiss: (id: number) => void
}

/* Совпадает с --duration-fast: уход быстрее входа (вход — --duration-normal),
   и элемент снимается тогда же, когда заканчивается переход, а не раньше и не
   позже. */
const LEAVE_MS = 120

let seq = 0
export const useToasts = create<ToastStore>((set) => ({
  items: [],
  push: (t) => {
    const id = ++seq
    set((s) => ({ items: [...s.items, { ...t, id }] }))
    setTimeout(() => useToasts.getState().dismiss(id), 4000)
  },
  dismiss: (id) =>
    set((s) => {
      // Сначала пометка, потом удаление — ровно через длительность ухода.
      setTimeout(() => set((x) => ({ items: x.items.filter((i) => i.id !== id) })), LEAVE_MS)
      return { items: s.items.map((i) => (i.id === id ? { ...i, leaving: true } : i)) }
    }),
}))

export const toast = (t: Omit<ToastItem, 'id'>): void => useToasts.getState().push(t)

const TONE_ICON: Record<ToastTone, string> = { info: 'info', success: 'check-check', danger: 'circle-alert' }

export function ToastHost() {
  const items = useToasts((s) => s.items)
  const dismiss = useToasts((s) => s.dismiss)
  return (
    <ol className="toast-viewport">
      {items.map((t) => (
        <li key={t.id} className={cn('toast', `toast--${t.tone}`)} data-leaving={t.leaving ? 'true' : undefined}>
          <Icon name={TONE_ICON[t.tone]} size={16} />
          <div style={{ flex: 1 }}>
            <div className="toast__title">{t.title}</div>
            {t.text && <div className="toast__text">{t.text}</div>}
          </div>
          <button className="icon-btn" aria-label="Закрыть" onClick={() => dismiss(t.id)}>
            <Icon name="x" size={14} />
          </button>
        </li>
      ))}
    </ol>
  )
}
